import type { Unsubscribe } from 'firebase/firestore';
import { startTaskSync } from './taskSync';
import { startHabitSync } from './habitSync';
import { startCompletionSync } from './completionSync';
import { startRoutineSync } from './routineSync';
import { startRunSync } from './runSync';
import { startPatternSync } from './patternSync';
import { startProfileSync } from './profileSync';
import { startSubscriptionSync } from './subscriptionSync';
import { useTaskStore } from '@/stores/taskStore';
import { useHabitStore } from '@/stores/habitStore';
import { useRoutineStore } from '@/stores/routineStore';
import { useUserPatternStore } from '@/stores/userPatternStore';
import { useSubscriptionStore } from '@/stores/subscriptionStore';

let unsubscribers: Unsubscribe[] = [];

export function startAllSync(uid: string): void {
  stopAllSync();
  unsubscribers = [
    startTaskSync(uid),
    startHabitSync(uid),
    startCompletionSync(uid),
    startRoutineSync(uid),
    startRunSync(uid),
    startPatternSync(uid),
    startProfileSync(uid),
    startSubscriptionSync(uid),
  ];
}

export function stopAllSync(): void {
  for (const unsub of unsubscribers) unsub();
  unsubscribers = [];
  useTaskStore.setState({ tasks: [] });
  useHabitStore.setState({ habits: [], completions: [] });
  useRoutineStore.setState({ routines: [], runs: [] });
  useUserPatternStore.getState().setPattern({
    peakStart: '09:00',
    peakEnd: '12:00',
    midStart: '14:00',
    midEnd: '17:00',
    lowWindows: ['12:00-13:00', '17:00-19:00'],
    avgCompletionRate: 0,
    skipPatterns: [],
    preferredTaskDuration: 30,
    updatedAt: new Date(0),
  });
  useUserPatternStore.setState({ completions: [] });
  useSubscriptionStore.getState().setSubscription({
    tier: 'free',
    expiresAt: null,
    willRenew: false,
    provider: null,
    productId: null,
    managementUrl: null,
    billingIssue: false,
  });
}
